import { ScrollingModule } from "@angular/cdk/scrolling";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "@app/material.module";
import { EstimationStatisticsGraphModule } from "@app/shared/estimation-statistics-graph/estimation-statistics-graph.module";
import { SatPopoverModule } from "@ncstate/sat-popover";
import { TranslateModule } from "@ngx-translate/core";
import { TaskFilterPopoverComponent } from "./task-filter-popover.component";

@NgModule({
	declarations: [TaskFilterPopoverComponent],
	imports: [
		CommonModule,
		SatPopoverModule,
		MaterialModule,
		FormsModule,
		ReactiveFormsModule,
		ScrollingModule,
		TranslateModule,
		EstimationStatisticsGraphModule,
	],
	exports: [TaskFilterPopoverComponent],
})
export class TaskFilterPopoverModule {}
